module.exports = "/_next/static/images/1d1c28b2dd28fd8cb92a52e5f9cc4e57-penal-circle.svg";